import themeVariables from './theme-variables';
function throwIfNotRecognised(theme, name) {
  if (theme && !Object.keys(themeVariables).includes(theme)) {
    var errorMessage = "Unrecognised theme \"".concat(theme, "\" found on ").concat(name, ".FE_BRARY_THEME");
    throw new Error(errorMessage);
  }
}

// set in the controller by fe-build's demo server
var feBuildDemoServerSideTheme = typeof global !== 'undefined' && global.FE_BRARY_THEME;
throwIfNotRecognised(feBuildDemoServerSideTheme, 'global');

// set in a HTML script tag by fe-build's demo server
var feBuildDemoClientSideTheme = typeof window !== 'undefined' && window.FE_BRARY_THEME;
throwIfNotRecognised(feBuildDemoClientSideTheme, 'window');

// set by webpack's DefinePlugin in production enviroments like fe-build/server
var feTheme = typeof process !== 'undefined' && process.env.FE_BRARY_THEME;
throwIfNotRecognised(feTheme, 'process.env');

// order very important here, prioritising fe-build demo
var theme = feBuildDemoServerSideTheme || feBuildDemoClientSideTheme || feTheme || 'domain';
export default theme;